/**
 * Changing this version will delete the entire Cache.
 */
export const SW_VERSION: number = 1.0;
export const BULK_SW: string = `motive-bulk-sw`;
export const BULK_SW_CHANNEL: string = `${BULK_SW}-channel`;
export const BULK_API_CACHE_DATA_CHANNEL: string = `bulk-api-cache-data-channel`;
export const BULK_CACHE_SUFFIX: string = `${BULK_SW}-v`;
export const CACHE_NAME: string = `${BULK_CACHE_SUFFIX}${SW_VERSION}`;

//#region Regex
export const BULK_REGEX: RegExp = new RegExp(/.*?\/api\/([^\/]+\/){2,}bulk/);
export const UPDATE_AFTER_REGEX: RegExp = new RegExp(/.*?\/api\/([^\/]+\/){2,}bulk\?.*updated_after=/);
//#endregion
